import { AttackRange, DamageType, ItemRarity, Weapon } from 'game/core'
import { ItemUI } from 'game/extended/uis/item_uis'

import image from './viking_axe.png'

export const viking_axe: ItemUI<Weapon> = {
    image,
    label: 'Viking axe',
    value: 125,
    item: {
        key: 'viking_axe',
        type: 'weapon',
        rarity: ItemRarity.Epic,
        stats: {
            strength: 50,
            agility: 50,
            armor: 20
        },
        two_handed: false,
        category: 'axe',
        damageType: DamageType.Melee,
        range: AttackRange.Melee,
        energy: 4,
        damage: 13
    }
}
